import { ErpCamposIntegracao, TipoProduto, SituacaoItemCompra } from 'px-business-components';
import { getCadastroAdicional } from '@/utils/cadastros-adicionais-utils';
import CadastrosAdicionais from '@/enums/cadastros-adicionais';

function isSituacaoValida(situacao) {
  return !situacao || situacao === SituacaoItemCompra.keys.ATIVO.key;
}

const hasCamposProdutoErpNeo = campoIntegracao => campoIntegracao.contaContabil !== null;

const hasCamposProdutoErpTotvs = campoIntegracao => campoIntegracao.contaContabil !== null
  && campoIntegracao.armazem !== null;

const hasCamposProdutoErpSenior = campoIntegracao => campoIntegracao.armazem !== null;

const hasCamposProdutoErpSeniorTeixeira = campoIntegracao => campoIntegracao.armazem !== null
  && campoIntegracao.contaContabil !== null && campoIntegracao.contaFinanceira !== null;

const hasCamposProdutoErpCrmSolucoes = campoIntegracao => campoIntegracao.contaDespesa !== null;

const hasCamposProdutoErpFocco = campoIntegracao => campoIntegracao.contaFinanceira !== null;

const hasCamposProdutoErpCasaShopping = campoIntegracao => campoIntegracao.contaDespesa !== null;

const hasCamposProdutoSeniorMega = campoIntegracao => campoIntegracao.operacao !== null
  && campoIntegracao.contaFinanceira !== null;

export const hasCadastrosAdicionaisProdutoErp = (tipoErp, camposIntegracao) => {
  if (tipoErp === ErpCamposIntegracao.keys.TOTVS.key) {
    return hasCamposProdutoErpTotvs(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.NEO.key) {
    return hasCamposProdutoErpNeo(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.SENIOR.key) {
    return hasCamposProdutoErpSenior(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.SENIOR_TEIXEIRA.key) {
    return hasCamposProdutoErpSeniorTeixeira(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.NEO_G7.key) {
    return hasCamposProdutoErpNeo(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.NEO_GABRIELLA.key) {
    return hasCamposProdutoErpNeo(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.CRM_SOLUCOES.key) {
    return hasCamposProdutoErpCrmSolucoes(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.FOCCO.key) {
    return hasCamposProdutoErpFocco(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.SENIOR_MEGA.key) {
    return hasCamposProdutoSeniorMega(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.CASA_SHOPPING.key) {
    return hasCamposProdutoErpCasaShopping(camposIntegracao);
  }
  return false;
};

const validateCamposErpSeniorTeixeira = (camposIntegracao, produto) => {
  if (!camposIntegracao.armazem && produto.tipoProduto === TipoProduto.keys.PRODUTO.key) {
    return [false, 'Depósito é obrigatório'];
  }
  if (!camposIntegracao.contaContabil) {
    return [false, 'Conta contábil é obrigatória'];
  }
  if (!camposIntegracao.contaFinanceira) {
    return [false, 'Conta financeira é obrigatória'];
  }
  return [true, null];
};

const validateCamposErpTotvs = (camposIntegracao) => {
  if (!camposIntegracao.armazem) {
    return [false, 'Armazém é obrigatório'];
  }
  if (!camposIntegracao.contaContabil) {
    return [false, 'Conta contábil é obrigatória'];
  }
  return [true, null];
};

const validateCamposErpSenior = (camposIntegracao) => {
  if (!camposIntegracao.armazem) {
    return [false, 'Depósito é obrigatório'];
  }
  return [true, null];
};

const validateCamposErpNeo = (camposIntegracao) => {
  if (!camposIntegracao.contaContabil) {
    return [false, 'Conta financeira é obrigatória'];
  }
  return [true, null];
};

const validateCamposErpNeoG7 = (camposIntegracao) => {
  if (!camposIntegracao.contaContabil) {
    return [false, 'Conta financeira é obrigatória'];
  }
  return [true, null];
};

const validateCamposErpCrmSolucoes = (camposIntegracao, type) => {
  if (!camposIntegracao.contaDespesa && type === 'COMPRA') {
    return [false, 'Conta de despesa é obrigatória'];
  }
  return [true, null];
};

const validateCamposErpFocco = (camposIntegracao, type) => {
  if (!camposIntegracao.contaFinanceira && type === 'COMPRA') {
    return [false, 'Conta financeira é obrigatória'];
  }
  return [true, null];
};

const validateCamposErpSeniorMega = (camposIntegracao, type) => {
  if (!camposIntegracao.contaFinanceira && type === 'COMPRA') {
    return [false, 'Classe financeira é obrigatória'];
  }
  if (!camposIntegracao.operacao && type === 'COMPRA') {
    return [false, 'Operação é obrigatória'];
  }
  return [true, null];
};
const validateCamposErpCasaShopping = (camposIntegracao, type) => {
  if (!camposIntegracao.contaDespesa && type === 'COMPRA') {
    return [false, 'Centro de custo é obrigatório'];
  }
  return [true, null];
};

export const validateCamposProdutoErp = (
  tipoErp,
  camposIntegracao,
  produto,
  situacaoItemCompra,
  type,
) => {
  if (!isSituacaoValida(situacaoItemCompra)) {
    return [true, null];
  }
  if (tipoErp === ErpCamposIntegracao.keys.TOTVS.key) {
    return validateCamposErpTotvs(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.NEO.key) {
    return validateCamposErpNeo(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.SENIOR.key) {
    return validateCamposErpSenior(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.SENIOR_TEIXEIRA.key) {
    return validateCamposErpSeniorTeixeira(camposIntegracao, produto);
  }
  if (tipoErp === ErpCamposIntegracao.keys.NEO_G7.key) {
    return validateCamposErpNeoG7(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.CRM_SOLUCOES.key) {
    return validateCamposErpCrmSolucoes(camposIntegracao, type);
  }
  if (tipoErp === ErpCamposIntegracao.keys.FOCCO.key) {
    return validateCamposErpFocco(camposIntegracao, type);
  }
  if (tipoErp === ErpCamposIntegracao.keys.SENIOR_MEGA.key) {
    return validateCamposErpSeniorMega(camposIntegracao, type);
  }
  if (tipoErp === ErpCamposIntegracao.keys.CASA_SHOPPING.key) {
    return validateCamposErpCasaShopping(camposIntegracao, type);
  }
  return [true, null];
};

export const computeFromProduto = (tipoErp, cadastrosAdicionais) => {
  if (tipoErp === ErpCamposIntegracao.keys.TOTVS.key) {
    return {
      armazem: getCadastroAdicional(cadastrosAdicionais, CadastrosAdicionais.keys.ARMAZEM.key),
      contaContabil: getCadastroAdicional(
        cadastrosAdicionais,
        CadastrosAdicionais.keys.CONTA_CONTABIL.key,
      ),
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.SENIOR.key) {
    return {
      armazem: getCadastroAdicional(
        cadastrosAdicionais,
        CadastrosAdicionais.keys.ARMAZEM.key,
      ),
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.SENIOR_TEIXEIRA.key) {
    return {
      armazem: getCadastroAdicional(
        cadastrosAdicionais,
        CadastrosAdicionais.keys.ARMAZEM.key,
      ),
      contaContabil: getCadastroAdicional(
        cadastrosAdicionais,
        CadastrosAdicionais.keys.CONTA_CONTABIL.key,
      ),
      contaFinanceira: getCadastroAdicional(
        cadastrosAdicionais,
        CadastrosAdicionais.keys.CONTA_FINANCEIRA.key,
      ),
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.NEO.key) {
    return {
      contaContabil: getCadastroAdicional(
        cadastrosAdicionais,
        CadastrosAdicionais.keys.CONTA_CONTABIL.key,
      ),
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.NEO_G7.key) {
    return {
      contaContabil: getCadastroAdicional(
        cadastrosAdicionais,
        CadastrosAdicionais.keys.CONTA_CONTABIL.key,
      ),
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.NEO_GABRIELLA.key) {
    return {
      contaContabil: getCadastroAdicional(
        cadastrosAdicionais,
        CadastrosAdicionais.keys.CONTA_CONTABIL.key,
      ),
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.CRM_SOLUCOES.key) {
    return {
      contaDespesa: getCadastroAdicional(
        cadastrosAdicionais,
        CadastrosAdicionais.keys.CONTA_DESPESA.key,
      ),
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.FOCCO.key) {
    return {
      contaFinanceira: getCadastroAdicional(
        cadastrosAdicionais,
        CadastrosAdicionais.keys.CONTA_FINANCEIRA.key,
      ),
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.SENIOR_MEGA.key) {
    return {
      operacao: getCadastroAdicional(cadastrosAdicionais, CadastrosAdicionais.keys.OPERACAO.key),
      contaFinanceira: getCadastroAdicional(
        cadastrosAdicionais,
        CadastrosAdicionais.keys.CONTA_FINANCEIRA.key,
      ),
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.CASA_SHOPPING.key) {
    return {
      contaDespesa: getCadastroAdicional(
        cadastrosAdicionais,
        CadastrosAdicionais.keys.CONTA_DESPESA.key,
      ),
    };
  }
  return {};
};

export const initialStateCamposProdutoErp = (tipoErp) => {
  if (tipoErp === ErpCamposIntegracao.keys.TOTVS.key) {
    return {
      armazem: null,
      contaContabil: null,
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.SENIOR.key) {
    return {
      armazem: null,
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.SENIOR_TEIXEIRA.key) {
    return {
      armazem: null,
      contaContabil: null,
      contaFinanceira: null,
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.NEO.key) {
    return {
      contaContabil: null,
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.NEO_G7.key) {
    return {
      contaContabil: null,
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.NEO_GABRIELLA.key) {
    return {
      contaContabil: null,
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.CRM_SOLUCOES.key) {
    return {
      contaDespesa: null,
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.FOCCO.key) {
    return {
      contaFinanceira: null,
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.SENIOR_MEGA.key) {
    return {
      operacao: null,
      contaFinanceira: null,
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.CASA_SHOPPING.key) {
    return {
      contaDespesa: null,
    };
  }
  return {};
};
